import object from '@mailobj-browser/front/js/utils/object.js'

export default text => {
  const {
    unread = 0,
    total = 0
  } = text
    .match(/(?:(?<unread>\d+)\s*\/\s*)?(?<total>\d+)/)
    ?.groups ?? { unread: 0, total: 0 }

  return object(null, { unread: parseInt(unread, 10), total: parseInt(total, 10) })
}
